import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { jsx as _jsx } from "react/jsx-runtime";
export var SearchLabelService = /*#__PURE__*/function () {
  function SearchLabelService(current, search) {
    _classCallCheck(this, SearchLabelService);

    _defineProperty(this, "current", void 0);

    _defineProperty(this, "search", void 0);

    this.current = current;
    this.search = search;
  }

  _createClass(SearchLabelService, [{
    key: "getLabelWithMarks",
    value: function getLabelWithMarks() {
      if (!this.isSearchedInCurrent()) {
        return this.current;
      }

      var currentValueLen = this.current.length;
      var searchValueLen = this.search.length;
      var textWithMarksCollection = Array.of('');
      var left = 0;
      var markValue = '';

      var pushMarkValue = function pushMarkValue() {
        if (markValue) {
          textWithMarksCollection.push( /*#__PURE__*/_jsx("b", {
            children: markValue
          }, left + markValue));
          markValue = '';
        }
      };

      while (left < currentValueLen) {
        var foundSubstring = this.current.substring(left, left + searchValueLen);

        if (foundSubstring.toLowerCase() === this.search.toLowerCase()) {
          markValue += foundSubstring;
          left += searchValueLen;
        } else {
          pushMarkValue();
          var lastResultItemIndex = textWithMarksCollection.length - 1;
          var _char = this.current[left];

          if (typeof textWithMarksCollection[lastResultItemIndex] === 'string') {
            textWithMarksCollection[lastResultItemIndex] += _char;
          } else {
            textWithMarksCollection.push(_char);
          }

          left += 1;
        }
      }

      pushMarkValue();
      return /*#__PURE__*/_jsx("span", {
        children: textWithMarksCollection
      });
    }
  }, {
    key: "isSearchedInCurrent",
    value: function isSearchedInCurrent() {
      var currentValueLen = this.current.length;
      var searchValueLen = this.search.length;
      return !!searchValueLen && searchValueLen <= currentValueLen && new RegExp(this.search, 'gi').test(this.current);
    }
  }, {
    key: "needAddCheckbox",
    value: function needAddCheckbox() {
      return !this.search || this.isSearchedInCurrent();
    }
  }, {
    key: "setCurrent",
    value: function setCurrent(current) {
      this.current = current;
      return this;
    }
  }, {
    key: "setSearch",
    value: function setSearch(search) {
      this.search = search;
      return this;
    }
  }]);

  return SearchLabelService;
}();